import { Button, ButtonProps } from 'antd';

const FancyButton = (props: ButtonProps) => {
  return (
    <Button
      {...props}
      className={`${props.type === 'default' ? '' : props.type === 'dashed' ? 'bg-transparent border-[1px] border-[#aaa] text-[#666] border-solid' : '!bg-[var(--theme-primary)] !text-[var(--theme-primary-text)]'} ${props.size === 'small' ? 'p-3' : 'p-5'} rounded-full border-0 hover:ring hover:ring-gray-300 ${props.className ?? ''}`}
    >
      {props.children}
    </Button>
  );
};

export default FancyButton;
